import { AbCopMapping } from './abcop';
import { ActionFighterMapping } from './afighterb';
import { AfterBurner2Mapping } from './aburner2';
import { AirRescueMapping } from './arescue';
import { AkkaArrhMapping } from './akkaarrh';
import { Alien3Mapping } from './alien3';
import { AmericanHorseShoesMapping } from './horshoes';
import { AngelKidsMapping } from './angelkds';
import { ArcadeClassicsMapping } from './arcadecl';
import { ArgusMapping } from './argusg';
import { ArkanoidMapping } from './arkanoid';
import { ArkanoidReturnsMapping } from './arkretrn';
import { AssaultMapping } from './assault';
import { AztaracMapping } from './aztarac';
import { BadlandsMapping } from './badlands';
import { BangMapping } from './bang';
import { BattleSharkMapping } from './bshark';
import { BattleZoneMapping } from './bzone';
import { BeastBustersMapping } from './bbusters';
import { BermudaTriangleMapping } from './bermudat';
import { BigRunMapping } from './bigrun';
import { BlackWidowMapping } from './bwidow';
import { BladesOfSteelMapping } from './bladestll';
import { BlasterMapping } from './blaster';
import { BoongGaBoongGaMapping } from './boonggab';
import { BuggyChallengeMapping } from './buggychl';
import { BulletMapping } from './bullet';
import { CabalMapping } from './cabaluk';
import { CameltryMapping } from './cameltry';
import { CapcomBowlingMapping } from './capbowl';
import { ChaseBombersMapping } from './cbombers';
import { ChaseHqMapping } from './chasehq';
import { ChequeredFlagMapping } from './chqflag';
import { CloakAndDaggerMapping } from './cloak';
import { ComplexXMapping } from './complexx';
import { ContinentalCircusMapping } from './contcirc';
import { CrazyClimberMapping } from './cclimber';
import { CrystalCastlesMapping } from './ccastles';
import { CyberTankMapping } from './cybertnk';
import { DDayMapping } from './dday';
import { DemolitionDerbyMapping } from './demoderb';
import { DirtFoxMapping } from './dirtfoxj';
import { DiscsOfTronMapping } from './dotron';
import { DoubleAxleMapping } from './dblaxle';
import { DribblingMapping } from './dribling';
import { DragonGunMapping } from './dragngun';
import { DynamicCountryClubMapping } from './dcclub';
import { EcoFightersMapping } from './ecofghtr';
import { EmpireStrikesBackMapping } from './esb';
import { EnduroRacerMapping } from './enduror';
import { EscapeFromPlanetOfRobotMonstersMapping } from './eprom';
import { ExterminatorMapping } from './exterm';
import { FaceoffMapping } from './faceoff';
import { FiretrapMapping } from './firetrap';
import { FoodFightMapping } from './foodf';
import { ForgottenWorldsMapping } from './forgottn';
import { FrontlineMapping } from './frontlin';
import { GalacticStormMapping } from './galastrm';
import { GalaxyForce2Mapping } from './gforce2';
import { GhoxMapping } from './ghox';
import { GlocAirBattleMapping } from './gloc';
import { GlocR360Mapping } from './glocr360';
import { GoindolMapping } from './goindol';
import { GoldenTee3dMapping } from './gt3d';
import { GondomaniaMapping } from './gondo';
import { GpRiderMapping } from './gprider';
import { GrandPrixStarMapping } from './f1gpstar';
import { GroundFxMapping } from './groundfx';
import { GunbusterMapping } from './gunbustr';
import { GunsmokeMapping } from './gunsmoke';
import { GuerrillaWarMapping } from './gwar';
import { HangOnMapping } from './hangon';
import { HangOnJrMapping } from './hangonjr';
import { HeavyBarrelMapping } from './hbarrel';
import { HeavyweightChampMapping } from './hwchamp';
import { HiddenCatch3Mapping } from './hidctch3';
import { HotRodMapping } from './hotrod';
import { HydraMapping } from './hydra';
import { IkariWarriorsMapping } from './ikari';
import { Ikari3Mapping } from './ikari3';
import { IrritatingMazeMapping } from './irrmaze';
import { JackalMapping } from './jackalr';
import { JoyfulRoadMapping } from './joyfulr';
import { JumpingPopMapping } from './jpopnics';
import { JurassicParkMapping } from './jpark';
import { KarateChampMapping } from './kchamp';
import { KickMapping } from './kick';
import { KonamiGtMapping } from './konamigt';
import { KozmikKroozrMapping } from './kroozr';
import { KnightmareMapping } from './kngtmare';
import { KrazyBowlMapping } from './krzybowl';
import { KrullMapping } from './krull';
import { LaserGhostMapping } from './lghost';
import { LethalEnforcersMapping } from './lethalen';
import { LostTombMapping } from './losttomb';
import { LibbleRablleMapping } from './liblrabl';
import { LineOfFireMapping } from './loffire';
import { LordOfGunMapping } from './lordgun';
import { LuckyAndWildMapping } from './luckywld';
import { LunarLanderMapping } from './llander';
import { MadPlanetsMapping } from './mplanets';
import { MajorLeagueMapping } from './mjleague';
import { MarsMapping } from './mars';
import { MaxRpmMapping } from './maxrpm';
import { MetalHawkMapping } from './metlhawk';
import { MobilSuitGundamFinalShootingMapping } from './gdfs';
import { MidnightResistanceMapping } from './midres';
import { MillipedeMapping } from './milliped';
import { MinefieldMapping } from './minefld';
import { MkMapping } from './mk';
import { NbaJamMapping } from './nbajam';
import { NightStrikerMapping } from './nightstr';
import { OmegaRaceMapping } from './omegrace';
import { OneShotOneKillMapping } from './oneshot';
import { OperationThunderboltMapping } from './othunder';
import { OperationWolfMapping } from './opwolf';
import { OutrunMapping } from './outrun';
import { OutrunnersMapping } from './orunners';
import { PointBlankMapping } from './ptblank';
import { PopNBounceMapping } from './popbounc';
import { PoundForPoundMapping } from './poundfor';
import { PowerDriftMapping } from './pdrift';
import { PowerUpBaseballMapping } from './pubball';
import { PuzzLoop2Mapping } from './pzloop2';
import { QuantumMapping } from './quantum';
import { RacingBeatMapping } from './racingb';
import { RacingHeroMapping } from './rachero';
import { RadMobileMapping } from './radm';
import { RailChaseMapping } from './rchase';
import { ReactorMapping } from './reactor';
import { RedBaronMapping } from './redbaron';
import { RescueMapping } from './rescue';
import { ReturnOfIshtarMapping } from './roishtar';
import { ReturnOfTheJediMapping } from './jedi';
import { RevolutionXMapping } from './revx';
import { RobotronMapping } from './robotron';
import { RockClimberMapping } from './rockclim';
import { RoughRacerMapping } from './roughrac';
import { SargeMapping } from './sarge';
import { ScrewLooseMapping } from './screwloo';
import { ScudHammerMapping } from './scudhamm';
import { SdiMapping } from './sdib';
import { SearchAndRescueMapping } from './searchar';
import { SinistarMapping } from './sinistar';
import { Sf2Mapping } from './sf2';
import { ShuffleshotMapping } from './shufshot';
import { ShuuzMapping } from './shuuz';
import { SlitherMapping } from './slither';
import { SmashTvMapping } from './smashtv';
import { SonicMapping } from './sonic';
import { SpaceDungeonMapping } from './sdungeon';
import { SpaceDuelMapping } from './spacduel';
import { SpaceGunMapping } from './spacegun';
import { SpaceHarrierMapping } from './sharrier';
import { SpecialCriminalInvestigationMapping } from './sci';
import { SpeedBallMapping } from './spdball';
import { SplatMapping } from './splat';
import { SpyHunterMapping } from './spyhunt';
import { StadiumCrossMapping } from './scross';
import { StarGuardsMapping } from './stargrds';
import { StarWarsMapping } from './starwars';
import { SteelGunnerMapping } from './sgunner';
import { SuperChaseMapping } from './superchs';
import { SuperMonacoGpMapping } from './smgp';
import { SyvalionMapping } from './syvalion';
import { TargetHitsMapping } from './targeth';
import { TempestMapping } from './tempest';
import { Terminator2Mapping } from './term2';
import { ThunderCeptorMapping } from './tceptor';
import { TimeSoldiersMapping } from './timesold';
import { TinStarMapping } from './tinstar';
import { TitleFightMapping } from './titlef';
import { Tnk3Mapping } from './tnk3';
import { ToobinMapping } from './toobin';
import { TopSpeedMapping } from './topspeed';
import { TronMapping } from './tron';
import { TutankhamMapping } from './tutankham';
import { TwoTigersMapping } from './twotiger';
import { UnderFireMapping } from './undrfire';
import { UsClassicMapping } from './usclssic';
import { VictoryRoadMapping } from './victroad';
import { VindicatorsMapping } from './vindictr';
import { Vindicators2Mapping } from './vindctr2';
import { WaterMatchMapping } from './wmatch';
import { WackoMapping } from './wacko';
import { WecLeMans24Mapping } from './wecleman';
import { WingShootingChampionshipMapping } from './wschamp';
import { WildPilotMapping } from './wildplt';
import { WildWesternMapping } from './wwestern';
import { WizWarzMapping } from './wizwarz';
import { WorldClassBowlingDeluxeMapping } from './wcbowldx';
import { WorldPkSoccerV2Mapping } from './wpksocv2';
import { ZeroPointMapping } from './zeropnt';
import { ZombieRaidMapping } from './zombraid';

export function findMapping(emuInput) {
  const { fbneoModule, emulator } = emuInput;

  const primaryName = emulator.getPrimaryName();
  const parentName = emulator.getParentName();

  const isName = (names) => {
    for (let i = 0; i < names.length; i++) {
      const n = names[i];
      if (n === primaryName || (parentName !== null && parentName === n)) {
        return true;
      }
    }
    return false;
  };

  /* A.B. Cop */
  if (isName(['abcop'])) {
    return new AbCopMapping(emuInput);
  }
  /* Action Fighter */
  if (isName(['afighterb', 'afighterd', 'afightere', 'afighterf'])) {
    return new ActionFighterMapping(emuInput);
  }
  /* After Burner 2 */
  if (isName(['aburner2'])) {
    return new AfterBurner2Mapping(emuInput);
  }
  /* Air Rescue */
  if (isName(['arescue'])) {
    return new AirRescueMapping(emuInput);
  }
  /*  Akka Arrh */
  if (isName(['akkaarrh'])) {
    return new AkkaArrhMapping(emuInput);
  }
  /*  Alien 3 */
  if (isName(['alien3'])) {
    return new Alien3Mapping(emuInput);
  }
  /* American Horseshoes */
  if (isName(['horshoes'])) {
    return new AmericanHorseShoesMapping(emuInput);
  }
  /* Arcade Classics */
  if (isName(['arcadecl'])) {
    return new ArcadeClassicsMapping(emuInput);
  }
  /* Argus */
  if (isName(['argusg'])) {
    return new ArgusMapping(emuInput);
  }
  /* Angel Kids */
  if (isName(['angelkds'])) {
    return new AngelKidsMapping(emuInput);
  }
  /* Arkanoid, Tournament Arkanoid */
  if (isName(['arkanoid', 'arkatour'])) {
    return new ArkanoidMapping(emuInput);
  }
  /* Arkanoid Returns, Puchi Carat */
  if (isName(['arkretrn', 'puchicar'])) {
    return new ArkanoidReturnsMapping(emuInput);
  }
  /* Assault */
  if (isName(['assault'])) {
    return new AssaultMapping(emuInput);
  }
  /* Aztarac */
  if (isName(['aztarac'])) {
    return new AztaracMapping(emuInput);
  }
  /* Badlands */
  if (isName(['badlands'])) {
    return new BadlandsMapping(emuInput);
  }
  /* Bang */
  if (isName(['bang'])) {
    return new BangMapping(emuInput);
  }
  /* Battle Shark */
  if (isName(['bshark'])) {
    return new BattleSharkMapping(emuInput);
  }
  /* Battle Zone */
  if (isName(['bzone'])) {
    return new BattleZoneMapping(emuInput);
  }
  /* Beast Busters */
  if (isName(['bbusters'])) {
    return new BeastBustersMapping(emuInput);
  }
  /* Bermuda Triangle, World Wars */
  if (isName(['bermudat', 'worldwar'])) {
    return new BermudaTriangleMapping(emuInput);
  }
  /* Big Run, Cisco Heat */
  if (isName(['bigrun', 'cischeat'])) {
    return new BigRunMapping(emuInput);
  }
  /* Black Widow */
  if (isName(['bwidow'])) {
    return new BlackWidowMapping(emuInput);
  }
  /* Blades of Steel (Trackball) */
  if (isName(['bladestll', 'bladestle'])) {
    return new BladesOfSteelMapping(emuInput);
  }
  /* Blaster */
  if (isName(['blaster'])) {
    return new BlasterMapping(emuInput);
  }
  /* Boong-Ga Boong-Ga */
  if (isName(['boonggab'])) {
    return new BoongGaBoongGaMapping(emuInput);
  }
  /* Buggy Challenge */
  if (isName(['buggychl'])) {
    return new BuggyChallengeMapping(emuInput);
  }
  /* Bullet */
  if (isName(['bullet'])) {
    return new BulletMapping(emuInput);
  }
  /* Cabal */
  if (isName(['cabaluk', 'cabalus', 'cabalus2'])) {
    return new CabalMapping(emuInput);
  }
  /* Cameltry */
  if (isName(['cameltry'])) {
    return new CameltryMapping(emuInput);
  }
  /* Capcom Bowling */
  if (isName(['capbowl', 'bowlrama'])) {
    return new CapcomBowlingMapping(emuInput);
  }
  /* Chase Bombers */
  if (isName(['cbombers'])) {
    return new ChaseBombersMapping(emuInput);
  }
  /* Chase H.Q. */
  if (isName(['chasehq'])) {
    return new ChaseHqMapping(emuInput);
  }
  /* Chequered Flag */
  if (isName(['chqflag'])) {
    return new ChequeredFlagMapping(emuInput);
  }
  /* Cloak and Dagger */
  if (isName(['cloak'])) {
    return new CloakAndDaggerMapping(emuInput);
  }
  /* Complex X */
  if (isName(['complexx'])) {
    return new ComplexXMapping(emuInput);
  }
  /* Continental Circus */
  if (isName(['contcirc'])) {
    return new ContinentalCircusMapping(emuInput);
  }
  /* Crazy Climber */
  if (isName(['cclimber'])) {
    return new CrazyClimberMapping(emuInput);
  }
  /* Crystal Castles */
  if (isName(['ccastles'])) {
    return new CrystalCastlesMapping(emuInput);
  }
  /* Cyber Tank */
  if (isName(['cybertnk'])) {
    return new CyberTankMapping(emuInput);
  }
  /* D-Day */
  if (isName(['dday'])) {
    return new DDayMapping(emuInput);
  }
  /* Demolition Derby */
  if (isName(['demoderb'])) {
    return new DemolitionDerbyMapping(emuInput);
  }
  /* Dirt Fox */
  if (isName(['dirtfoxj'])) {
    return new DirtFoxMapping(emuInput);
  }
  /* Discs of Tron */
  if (isName(['dotron'])) {
    return new DiscsOfTronMapping(emuInput);
  }
  /* Double Axle */
  if (isName(['dblaxle'])) {
    return new DoubleAxleMapping(emuInput);
  }
  /* Dribblng */
  if (isName(['dribling'])) {
    return new DribblingMapping(emuInput);
  }
  /* Dragon Gun */
  if (isName(['dragngun'])) {
    return new DragonGunMapping(emuInput);
  }
  /* Dynamic Country Club */
  if (isName(['dcclub'])) {
    return new DynamicCountryClubMapping(emuInput);
  }
  /* Eco Fighters */
  if (isName(['ecofghtr'])) {
    return new EcoFightersMapping(emuInput);
  }
  /* Empire Strikes Back */
  if (isName(['esb'])) {
    return new EmpireStrikesBackMapping(emuInput);
  }
  /* Enduro Racer */
  if (isName(['enduror'])) {
    return new EnduroRacerMapping(emuInput);
  }
  /* Escape from the Planet of the Robot Monsters */
  if (isName(['eprom'])) {
    return new EscapeFromPlanetOfRobotMonstersMapping(emuInput);
  }
  /* Exterminator */
  if (isName(['exterm'])) {
    return new ExterminatorMapping(emuInput);
  }
  /* Faceoff */
  if (isName(['faceoff'])) {
    return new FaceoffMapping(emuInput);
  }
  /* Firetrap */
  if (isName(['firetrap'])) {
    return new FiretrapMapping(emuInput);
  }
  /* Food Fight */
  if (isName(['foodf'])) {
    return new FoodFightMapping(emuInput);
  }
  /* Forgotten Worlds */
  if (isName(['forgottn'])) {
    return new ForgottenWorldsMapping(emuInput);
  }
  /* Frontline */
  if (isName(['frontlin'])) {
    return new FrontlineMapping(emuInput);
  }
  /* G-LOC Air Battle, Strike Fighter */
  if (isName(['gloc', 'strkfgtr'])) {
    return new GlocAirBattleMapping(emuInput);
  }
  /* G-LOC R360 */
  if (isName(['glocr360', 'glocr360j'])) {
    return new GlocR360Mapping(emuInput);
  }
  /* Galactic Storm */
  if (isName(['galastrm'])) {
    return new GalacticStormMapping(emuInput);
  }
  /* Galaxy Force 2, Thunder Blade */
  if (isName(['gforce2', 'thndrbld'])) {
    return new GalaxyForce2Mapping(emuInput);
  }
  /* Ghox */
  if (isName(['ghox'])) {
    return new GhoxMapping(emuInput);
  }
  /* Goindol */
  if (isName(['goindol'])) {
    return new GoindolMapping(emuInput);
  }
  /* Gold Tee 3d */
  if (isName(['gt3d', 'gt97', 'gt98', 'gt99', 'gt2k', 'gtclassc'])) {
    return new GoldenTee3dMapping(emuInput);
  }
  /* Gondomania */
  if (isName(['gondo'])) {
    return new GondomaniaMapping(emuInput);
  }
  /* GP Rider */
  if (isName(['gprider'])) {
    return new GpRiderMapping(emuInput);
  }
  /* Grand Prix Star */
  if (isName(['f1gpstar'])) {
    return new GrandPrixStarMapping(emuInput);
  }
  /* Ground Effects */
  if (isName(['groundfx'])) {
    return new GroundFxMapping(emuInput);
  }
  /* Gunbustr */
  if (isName(['gunbustr'])) {
    return new GunbusterMapping(emuInput);
  }
  /* Gunsmoke */
  if (isName(['gunsmoke'])) {
    return new GunsmokeMapping(emuInput);
  }
  /* Guerrilla War */
  if (isName(['gwar'])) {
    return new GuerrillaWarMapping(emuInput);
  }
  /* Hang On, Super Hang On */
  if (isName(['hangon', 'shangon'])) {
    return new HangOnMapping(emuInput);
  }
  /* Hang On Jr. */
  if (isName(['hangonjr'])) {
    return new HangOnJrMapping(emuInput);
  }
  /* Heavy Barrel */
  if (isName(['hbarrel'])) {
    return new HeavyBarrelMapping(emuInput);
  }
  /* Heavyweight Champ */
  if (isName(['hwchamp'])) {
    return new HeavyweightChampMapping(emuInput);
  }
  /* Hidden Catch 3 */
  if (isName(['hidctch3'])) {
    return new HiddenCatch3Mapping(emuInput);
  }
  /* Hot Rod */
  if (isName(['hotrod'])) {
    return new HotRodMapping(emuInput);
  }
  /* Hydra */
  if (isName(['hydra'])) {
    return new HydraMapping(emuInput);
  }
  /* Ikari Warriors */
  if (isName(['ikari'])) {
    return new IkariWarriorsMapping(emuInput);
  }
  /* Ikari 3 */
  if (isName(['ikari3'])) {
    return new Ikari3Mapping(emuInput);
  }
  /* Irritating Maze */
  if (isName(['irrmaze'])) {
    return new IrritatingMazeMapping(emuInput);
  }
  /* Jackal */
  if (isName(['jackalr', 'jackalbl', 'topgunbl'])) {
    return new JackalMapping(emuInput);
  }
  /* Joyful Road */
  if (isName(['joyfulr'])) {
    return new JoyfulRoadMapping(emuInput);
  }
  /* Jumping Pop, Plump Pop, Arkanoid - Revenge of DOH */
  if (isName(['jpopnics', 'plumppop', 'arknoid2'])) {
    return new JumpingPopMapping(emuInput);
  }
  /* Jurassic Park */
  if (isName(['jpark'])) {
    return new JurassicParkMapping(emuInput);
  }
  /* Karate Champ */
  if (isName(['kchamp'])) {
    return new KarateChampMapping(emuInput);
  }
  /* Kick (dpoker? unable to find rom)*/
  if (isName(['kick', 'dpoker'])) {
    return new KickMapping(emuInput);
  }
  /* Knightmare */
  if (isName(['kngtmare'])) {
    return new KnightmareMapping(emuInput);
  }
  /* Konami GT */
  if (isName(['konamigt'])) {
    return new KonamiGtMapping(emuInput);
  }
  /* Kozmik Kroozr */
  if (isName(['kroozr'])) {
    return new KozmikKroozrMapping(emuInput);
  }
  /* Krazy Bowl */
  if (isName(['krzybowl'])) {
    return new KrazyBowlMapping(emuInput);
  }
  /* Krull */
  if (isName(['krull'])) {
    return new KrullMapping(emuInput);
  }
  /* Laser Ghost */
  if (isName(['lghost'])) {
    return new LaserGhostMapping(emuInput);
  }
  /* Lethal Enforcers */
  if (isName(['lethalen'])) {
    return new LethalEnforcersMapping(emuInput);
  }
  /* Libble Rablle */
  if (isName(['liblrabl'])) {
    return new LibbleRablleMapping(emuInput);
  }
  /* Line of Fire */
  if (isName(['loffire'])) {
    return new LineOfFireMapping(emuInput);
  }
  /* Lord of Gun */
  if (isName(['lordgun'])) {
    return new LordOfGunMapping(emuInput);
  }
  /* Lost Tomb */
  if (isName(['losttomb'])) {
    return new LostTombMapping(emuInput);
  }
  /* Lucky and Wild */
  if (isName(['luckywld'])) {
    return new LuckyAndWildMapping(emuInput);
  }
  /* Lunar Lander */
  if (isName(['llander'])) {
    return new LunarLanderMapping(emuInput);
  }
  /* Mad Planets */
  if (isName(['mplanets'])) {
    return new MadPlanetsMapping(emuInput);
  }
  /* Major League */
  if (isName(['mjleague'])) {
    return new MajorLeagueMapping(emuInput);
  }
  /* Mars */
  if (isName(['mars'])) {
    return new MarsMapping(emuInput);
  }
  /* Max Rpm */
  if (isName(['maxrpm'])) {
    return new MaxRpmMapping(emuInput);
  }
  /* Mortal Kombat */
  if (isName(['mk', 'mk2', 'mk3', 'umk3'])) {
    return new MkMapping(emuInput);
  }
  /* Centipede, Millipede */
  if (isName(['centiped', 'milliped'])) {
    return new MillipedeMapping(emuInput);
  }
  /* Metal Hawk */
  if (isName(['metlhawk'])) {
    return new MetalHawkMapping(emuInput);
  }
  /* Midnight Resistance */
  if (isName(['midres'])) {
    return new MidnightResistanceMapping(emuInput);
  }
  /* Minefield */
  if (isName(['minefld'])) {
    return new MinefieldMapping(emuInput);
  }
  /* Mobil Suit Gundam Final Shooting */
  if (isName(['gdfs'])) {
    return new MobilSuitGundamFinalShootingMapping(emuInput);
  }
  /* Nba Jam */
  if (isName(['nbajam', 'nbahangt', 'nbajamte', 'nbamht'])) {
    return new NbaJamMapping(emuInput);
  }
  /* Night Striker */
  if (isName(['nightstr'])) {
    return new NightStrikerMapping(emuInput);
  }
  /* Omega Race */
  if (isName(['omegrace'])) {
    return new OmegaRaceMapping(emuInput);
  }
  /* One Shot One Kill */
  if (isName(['oneshot'])) {
    return new OneShotOneKillMapping(emuInput);
  }
  /* Operation Thunberbolt */
  if (isName(['othunder'])) {
    return new OperationThunderboltMapping(emuInput);
  }
  /* Operation Wolf, Operation Wolf 3 */
  if (isName(['opwolf', 'opwolf3'])) {
    return new OperationWolfMapping(emuInput);
  }
  /* Outrun, Turbo Outrun */
  if (isName(['outrun', 'toutrun'])) {
    return new OutrunMapping(emuInput);
  }
  /* Outrunners */
  if (isName(['orunners'])) {
    return new OutrunnersMapping(emuInput);
  }
  /* Point Blank */
  if (isName(['ptblank'])) {
    return new PointBlankMapping(emuInput);
  }
  /* Pop N Bounce */
  if (isName(['popbounc'])) {
    return new PopNBounceMapping(emuInput);
  }
  /* Pop N Bounce */
  if (isName(['poundfor'])) {
    return new PoundForPoundMapping(emuInput);
  }
  /* Power Drift */
  if (isName(['pdrift'])) {
    return new PowerDriftMapping(emuInput);
  }
  /* Power Up Baseball */
  if (isName(['pubball'])) {
    return new PowerUpBaseballMapping(emuInput);
  }
  /* Puzz Loop 2 */
  if (isName(['pzloop2'])) {
    return new PuzzLoop2Mapping(emuInput);
  }
  /* Quantum */
  if (isName(['quantum'])) {
    return new QuantumMapping(emuInput);
  }
  /* F1 External Note, F1 Super Lap, Rad Mobile, Rad Rally, Slipstream */
  if (isName(['f1en', 'f1lap', 'radm', 'radr', 'slipstrm'])) {
    return new RadMobileMapping(emuInput);
  }
  /* Racing Beat */
  if (isName(['racingb'])) {
    return new RacingBeatMapping(emuInput);
  }
  /* Racing Hero */
  if (isName(['rachero'])) {
    return new RacingHeroMapping(emuInput);
  }
  /* Rail Chase */
  if (isName(['rchase'])) {
    return new RailChaseMapping(emuInput);
  }
  /* Reactor */
  if (isName(['reactor'])) {
    return new ReactorMapping(emuInput);
  }
  /* Rescue */
  if (isName(['rescue'])) {
    return new RescueMapping(emuInput);
  }
  /* Red Baron */
  if (isName(['redbaron'])) {
    return new RedBaronMapping(emuInput);
  }
  /* Return of Ishtar */
  if (isName(['roishtar'])) {
    return new ReturnOfIshtarMapping(emuInput);
  }
  /* Return of The Jedi */
  if (isName(['jedi'])) {
    return new ReturnOfTheJediMapping(emuInput);
  }
  /* RevolutionX */
  if (isName(['revx'])) {
    return new RevolutionXMapping(emuInput);
  }
  /* Robotron */
  if (isName(['robotron'])) {
    return new RobotronMapping(emuInput);
  }
  /* Rock Climber */
  if (isName(['rockclim'])) {
    return new RockClimberMapping(emuInput);
  }
  /* Rough Racer */
  if (isName(['roughrac'])) {
    return new RoughRacerMapping(emuInput);
  }
  /* Sarge */
  if (isName(['sarge'])) {
    return new SargeMapping(emuInput);
  }
  /* Screw Loose */
  if (isName(['screwloo'])) {
    return new ScrewLooseMapping(emuInput);
  }
  /* Scud Hammer */
  if (isName(['scudhamm'])) {
    return new ScudHammerMapping(emuInput);
  }
  /* SDI - Strategic Defense Initiative */
  if (
    isName([
      'sdi',
      'sdib',
      'sdibl',
      'sdibl2',
      'sdibl3',
      'sdibl4',
      'sdibl5',
      'sdibl6',
      'defense',
    ])
  ) {
    return new SdiMapping(emuInput);
  }
  /* Search and Rescue */
  if (isName(['searchar'])) {
    return new SearchAndRescueMapping(emuInput);
  }
  /* Shuffleshot */
  if (isName(['shufshot'])) {
    return new ShuffleshotMapping(emuInput);
  }
  /* Sinistar */
  if (isName(['sinistar'])) {
    return new SinistarMapping(emuInput);
  }
  /* Slither */
  if (isName(['slither'])) {
    return new SlitherMapping(emuInput);
  }
  /* Smash T.V., Total Carnage */
  if (isName(['shuuz'])) {
    return new ShuuzMapping(emuInput);
  }
  /* Smash T.V., Total Carnage */
  if (isName(['smashtv', 'totcarn'])) {
    return new SmashTvMapping(emuInput);
  }
  /* Sonic */
  if (isName(['sonic'])) {
    return new SonicMapping(emuInput);
  }
  /* Space Duel */
  if (isName(['spacduel'])) {
    return new SpaceDuelMapping(emuInput);
  }
  /* Space Dungeon */
  if (isName(['sdungeon'])) {
    return new SpaceDungeonMapping(emuInput);
  }
  /* Space Gun */
  if (isName(['spacegun'])) {
    return new SpaceGunMapping(emuInput);
  }
  /* Space Harrier */
  if (isName(['sharrier'])) {
    return new SpaceHarrierMapping(emuInput);
  }
  /* Special Criminal Investigation */
  if (isName(['sci'])) {
    return new SpecialCriminalInvestigationMapping(emuInput);
  }
  /* Speedball */
  if (isName(['spdball'])) {
    return new SpeedBallMapping(emuInput);
  }
  /* Splat! */
  if (isName(['splat'])) {
    return new SplatMapping(emuInput);
  }
  /* Spy Hunter */
  if (isName(['spyhunt'])) {
    return new SpyHunterMapping(emuInput);
  }
  /* Stadium Cross */
  if (isName(['scross'])) {
    return new StadiumCrossMapping(emuInput);
  }
  /* Star Guards */
  if (isName(['stargrds'])) {
    return new StarGuardsMapping(emuInput);
  }
  /* Star Wars */
  if (isName(['starwars'])) {
    return new StarWarsMapping(emuInput);
  }
  /* Steel Gunner, Steel Gunner 2 */
  if (isName(['sgunner', 'sgunner2'])) {
    return new SteelGunnerMapping(emuInput);
  }
  /* Street Fighter */
  if (fbneoModule._isStreetFighterLayout()) {
    return new Sf2Mapping(emuInput);
  }
  /* Super Chase - Criminal Investigation */
  if (isName(['superchs'])) {
    return new SuperChaseMapping(emuInput);
  }
  /* Super Monaco GP */
  if (isName(['smgp'])) {
    return new SuperMonacoGpMapping(emuInput);
  }
  /* Syvalion */
  if (isName(['syvalion'])) {
    return new SyvalionMapping(emuInput);
  }
  /* Target Hits */
  if (isName(['targeth'])) {
    return new TargetHitsMapping(emuInput);
  }
  /* Tempest */
  if (isName(['tempest'])) {
    return new TempestMapping(emuInput);
  }
  /* Terminator 2 */
  if (isName(['term2'])) {
    return new Terminator2Mapping(emuInput);
  }
  /* The Tin Star */
  if (isName(['tinstar'])) {
    return new TinStarMapping(emuInput);
  }
  /* Thunder Ceptor */
  if (isName(['tceptor'])) {
    return new ThunderCeptorMapping(emuInput);
  }
  /* Time Soldiers, Battle Field */
  if (isName(['btlfield', 'timesold'])) {
    return new TimeSoldiersMapping(emuInput);
  }
  /* Title Fight */
  if (isName(['titlef'])) {
    return new TitleFightMapping(emuInput);
  }
  /* Tnk 3 */
  if (isName(['tnk3'])) {
    return new Tnk3Mapping(emuInput);
  }
  /* Toobin' */
  if (isName(['toobin'])) {
    return new ToobinMapping(emuInput);
  }
  /* Top Speed */
  if (isName(['topspeed'])) {
    return new TopSpeedMapping(emuInput);
  }
  /* Tron */
  if (isName(['tron'])) {
    return new TronMapping(emuInput);
  }
  /* Tutankham */
  if (isName(['tutankhm'])) {
    return new TutankhamMapping(emuInput);
  }
  /* Two Tigers */
  if (isName(['twotiger'])) {
    return new TwoTigersMapping(emuInput);
  }
  /* U.S. Classic */
  if (isName(['usclssic'])) {
    return new UsClassicMapping(emuInput);
  }
  /* Under Fire */
  if (isName(['undrfire'])) {
    return new UnderFireMapping(emuInput);
  }
  /* Victory Road */
  if (isName(['victroad'])) {
    return new VictoryRoadMapping(emuInput);
  }
  /* Vindicators */
  if (isName(['vindictr'])) {
    return new VindicatorsMapping(emuInput);
  }
  /* Vindicators 2 */
  if (isName(['vindctr2'])) {
    return new Vindicators2Mapping(emuInput);
  }
  /* Wacko */
  if (isName(['wacko'])) {
    return new WackoMapping(emuInput);
  }
  /* Water Match */
  if (isName(['wmatch'])) {
    return new WaterMatchMapping(emuInput);
  }
  /* WEC Le Mans 24 (and Hot Chase) */
  if (isName(['wecleman', 'hotchase'])) {
    return new WecLeMans24Mapping(emuInput);
  }
  /* Wild Pilot */
  if (isName(['wildplt'])) {
    return new WildPilotMapping(emuInput);
  }
  /* Wild Western */
  if (isName(['wwestern'])) {
    return new WildWesternMapping(emuInput);
  }
  /* Deer Hunting, Wing Shooting Championship, Trophy Hunting - Bear & Moose, Turkey Hunting */
  if (isName(['wschamp', 'trophyh', 'deerhunt', 'turkhunt'])) {
    return new WingShootingChampionshipMapping(emuInput);
  }
  /* Wiz Warz */
  if (isName(['wizwarz'])) {
    return new WizWarzMapping(emuInput);
  }
  /* World Class Bowling Deluxe */
  if (isName(['wcbowl', 'wcbowldx'])) {
    return new WorldClassBowlingDeluxeMapping(emuInput);
  }
  /* World PK Soccer */
  if (isName(['wpksocv2'])) {
    return new WorldPkSoccerV2Mapping(emuInput);
  }
  /* Zero Point, Zero Point 2 */
  if (isName(['zeropnt', 'zeropnt2'])) {
    return new ZeroPointMapping(emuInput);
  }
  /* Zombie Raid */
  if (isName(['zombraid'])) {
    return new ZombieRaidMapping(emuInput);
  }

  return null;
}

//
// Twin Stick
//

// * Angel Kids (Japan)
// * Assault
// * Battle Zone (set 1)
// * Black Widow
// * Bullet (FD1094 317-0041)
// * Cloak & Dagger (rev 5)
// * Complex X
// * Crazy Climber (US)
// * Crazy Climber 2 (Japan)
// - Draco
// * Dribbling
// * Face Off (Japan)
// * Fire Trap (US)
// * Front Line
// - Hat Trick
// - Hyperdrive
// * Ikari Warriors
// * Ikari 3
// - Indoor Soccer
// - Inferno
// * Joyful Road (Japan)
// * Karate Champ (US)
// * Knightmare (prototype)
// * Krull
// * Libble Rabble
// * Lost Tomb (easy)
// * Mars
// * Minefield
// - Off the Wall (Sente)
// - QB-3 (prototype)
// * Rescue
// - Rescue Raider
// * Robotron (Solid Blue label)
// * Rock Climber
// * Sarge
// * Screw Loose (prototype)
// - Sente Diagnostic Cartridge
// - Sheriff
// * Smash T.V. (rev 8.00)
// - Snake Pit
// * Space Dungeon
// * Splat!
// * Star Guards
// - Stompin'
// - Tank 8 (set 1)
// * The Return of Ishtar
// * The Tin Star (set 1)
// * Title Fight (World)
// - Toggle (prototype)
// * Total Carnage (rev LA1 03/10/92)
// - Trivial Pursuit (All Star Sports Edition)
// - Trivial Pursuit (Baby Boomer Edition)
// - Trivial Pursuit (Genus I) (set 1)
// - Trivial Pursuit (Genus I) (set 2)
// - Trivial Pursuit (Genus II)
// - Trivial Pursuit (Spanish Edition)
// - Trivial Pursuit (Young Players Edition)
// - Ultra Tank
// * Vindicators (rev 5)
// * Vindicators Part II (rev 3)
// * Water Match (315-5064)
// * Wild Western (set 1)

//
// Analog
//

// * A.B. Cop
// * Action Fighter
// * After Burner 2
// * Air Rescue
// * Akka Arrh
// * Alien 3
// * American Horseshoes
// * Arcade Classics
// * Argus
// * Arkanoid, Tournament Arkanoid
// * Arkanoid - Revenge of DOH
// * Arkanoid Returns
// * Aztarac
// * Badlands
// * Bang
// * Battle Shark
// * Beast Busters (J and JA)
// * Big Run
// * Blades of Steel (Trackball)
// * Blaster
// * Boong-Ga Boong-Ga
// * Buggy Challenge
// * Bowl-o-Rama
// * Cabal (UK, US, US2)
// * Cameltry
// * Capcom Bowling
// * Centipede
// * Chase Bombers
// * Chase H.Q.
// * Checkered Flag
// * Cisco Heat
// * Continental Circus
// * Crystal Castles
// * Cyber Tank
// * D-Day
// * Deer Hunting
// * Demolition Derby
// * Dirt Fox
// * Discs of Tron
// * Double Axle
// * Dragon Gun
// * Dynamic Country Club
// * Empire Strikes Back
// * Enduro Racer
// * Escape from the Planet of the Robot Monsters
// * Exterminator
// * F1 External Note
// * F1 Super Lap
// * Food Fight
// * Forgotten Worlds
// * G-LOC Air Battle
// * G-LOC R360
// * Galactic Storm
// * Galaxy Force 2
// * Ghox
// * Goindol
// * Golden Tee 3d
// * GP Rider
// * Grand Prix Star
// * Ground Effects / Super Ground Effects
// * Gunbustr
// * HangOn
// * HangOn Jr.
// * Heavyweight Champ
// * Hidden Catch 3
// * Hot Rod
// * Hydra
// * Irritating Maze
// * Jumping Pop
// * Jurassic Park
// * Kick
// * Kozmik Kroozr
// * Konami GT
// * Krazy Bowl
// * Laser Ghost
// * Lethal Enforcers
// * Line of Fire
// * Lord of Gun
// * Lucky and Wild
// * Lunar Lander
// * Major League
// * Max RPM
// * Metal Hawk
// * Millipede
// * Mobil Suit Gundam Final Shooting
// * Night Striker
// * Omega Race
// * One Shot One Kill
// * Operation Thunderbolt
// * Operation Wolf
// * Operation Wolf 3
// * Outrun
// * Outrunners
// & Pachinko Sexy Reaction & 2 (not mapped, using digital)
// * Plump Pop
// * Point Blank
// * Pop 'n Bounce (Must enable paddle w/ soft dip)
// * Pound for Pound
// * Power Drift
// * Power Up Baseball
// * Puzz Loop 2
// * Quantum
// * Racing Beat
// * Racing Hero
// * Rad Mobile
// * Rad Rally
// * Rail Chase
// * Rambo3 (Not mapped, use digital)
// * Reactor
// * Red Baron
// * Return of the Jedi
// * Revolution X
// * Rough Racer
// * Scud Hammer
// * SDI - Strategic Defense Initiative
// * Search and Rescue
// * Shuuz
// * Shuuz 2
// * Shuffleshot
// * Sinistar
// * Slipstream
// * Slither
// * Sonic
// * Space Gun
// * Space Harrier
// * Special Criminal Investigation
// * Speed Ball - Contest at Neonworld
// * Spy Hunter
// * Stadium Cross
// * Star Wars
// * Steel Gunner & Steel Gunner 2
// * Strike Fighter
// * Super Chase - Criminal Termination
// * Super Hang-On
// * Super Monaco GP
// * Syvalion
// * Target Hits
// * Tempest
// * Terminator 2
// * Thunder Blade
// * Thunder Ceptor
// * Top Speed
// * Tron
// * Trophy Hunting - Bear & Moose
// * Turbo Outrun
// * Turkey Hunting
// * Two Tigers
// * U.S. Classic
// * Under Fire
// * VS Block Breaker (Not mapped, digital work better...)
// * Wacko
// * WEC Le Mans 24 (and Hot Chase)
// * Wild Pilot
// * Wing Shooting Championship
// * Wiz Warz
// * World Class Bowling Deluxe
// * World PK Soccer V2
// * Zero Point
// * Zero Point 2
// * Zombie Raid

//
// Misc
//

// * Space Duel
// * Arkanoid Returns - Load NVRAM with Analog Controls enabled
// * Puchi Carat - Load NVRAM with Analog Controls enabled
// * Slither - Save SRAM (brings up diagnostics)
// * Line of Fire - Save SRAM
// * Laser Ghost - Save SRAM

//
// DrvFakeInput
//

// * Heavy Barrel
// * Midnight Resistance
// * Gondomania
// * Jackal
// * Time Soldiers
// * Battle Field
// * Mad Planets
// * Guerrilla War
// * Tnk 3
// * Ikari Warriors
// * Victory Road
// * Bermuda Triangle
// * World Wars
// * Search and Rescue
// * Ikari 3

//
// TODO:
//

// Heavyweight Champ - Not sure how controls work
// Major League - Controls don't seem right
// Action Fighter (Analog) - Controls are not right
// DownTown / Mokugeki - No buttons to rotate (like DrvFakeInput)
// Caliber 50 - No buttons to rotate (like DrvFakeInput)
